import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  TextField,
  MenuItem,
  Button,
  Box,
} from '@mui/material';
import { updateUserDetailsFormValue, updateUserDetails, getEditDetails, resetEditForm } from '../../reducers/userEditForm';

const EditForm = () => {
  const dispatch = useDispatch();
  const { email, name, organization, role, user_id } = useSelector(getEditDetails);
  const currentUser_id = useSelector(({ currentUser: { user_id } }) => ({ user_id }));

  const adminIsEditingOwn = (user_id === currentUser_id.user_id);

  const handleChange = (event) => {
    const { id, value } = event.target;
    dispatch(updateUserDetailsFormValue({ key: id, value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    dispatch(updateUserDetails());
  };

  useEffect(() => () => dispatch(resetEditForm()), []);

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        '& .MuiTextField-root': { m: 1, width: '30ch' },
      }}
    >
      <TextField
        id="email"
        label="Email address"
        type="email"
        variant="outlined"
        required
        autoFocus
        value={email}
        onChange={handleChange}
      />
      <TextField
        id="name"
        label="Full name"
        type="text"
        variant="outlined"
        value={name}
        onChange={handleChange}
      />
      <TextField
        id="organization"
        label="Organization"
        type="text"
        variant="outlined"
        value={organization}
        onChange={handleChange}
      />
      <TextField
        disabled={adminIsEditingOwn}
        id="role"
        label="Role"
        variant="outlined"
        select
        value={role}
        onChange={(event) => {
          const { value } = event.target;
          dispatch(updateUserDetailsFormValue({ key: 'role', value }));
        }}
      >
        <MenuItem value="user">User</MenuItem>
        <MenuItem value="admin">Admin</MenuItem>
      </TextField>
      <Button type="submit" variant="contained" color="primary">
        Save changes
      </Button>

    </Box>

  );
};

export default EditForm;
